

































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class ModalError extends Vue {
  @Prop({ default: 'modal-api-exceed' }) private id!: string
  @Prop({ default: 3 }) private closeSeconds!: number
  @Prop({ default: false }) private autoClose!: boolean

  hideModal() {
    this.$bvModal.hide(this.id)
    setTimeout(() => {
      this.$emit('close')
      clearTimeout()
    }, 300)
  }

  hanldeAutoClose() {
    if (this.autoClose) {
      setTimeout(() => {
        this.$bvModal.hide(this.id)
        clearTimeout()
      }, this.closeSeconds * 1000)
    }
  }
}
